import { Form } from "element-ui";
import { patchData, scrollElementFormErrorIntoView } from "@/utils";
import { Prop, Vue, Watch } from "vue-property-decorator";
import { FormModel } from "@/service/common/entity/FormModel";
import { SupplierFormCtrl } from "./SupplierFormCtrl";
import { SupplierInfoSubmitBO } from "@/service/supplier-meta/entity/SupplierInfoSubmitBO";
import {
  getFieldRules,
  getFieldsRules,
  isFieldVisible,
  getFieldCtrlFn,
  getFieldsCtrlFn,
  isFieldRequired,
  ElementUIFormItemRule,
  ElementUIFormRules,
} from "@/service/supplier-meta/common/supplier-field-ctrl";
export abstract class SupplierForm extends Vue {
  /** 供应商来源（入口） */
  @Prop() sourceType!: number;
  /** 提交的数据 */
  @Prop() submitData!: SupplierInfoSubmitBO;
  /** 是否是服装品类 */
  @Prop() isClothingCategory!: boolean;
  abstract form: FormModel;
  @Watch("form", {
    deep: true,
  })
  handleFormValueChange(val: FormModel) {
    const partFormData = this.getFormData(val);
    let parent = this.$parent;
    while (parent && !(parent instanceof SupplierFormCtrl)) {
      parent = parent.$parent;
    }
    if (parent && parent instanceof SupplierFormCtrl) {
      parent.patchFormData(partFormData);
    }
    this.$emit("formValueChange", this.form);
  }
  /**
   * 将数据合并到提交的表单数据
   */
  abstract getFormData(val?: FormModel): FormModel;
  getFieldRules(fieldName: string): ElementUIFormItemRule[] {
    const getRules = getFieldCtrlFn<ElementUIFormItemRule[]>(
      getFieldRules,
      this.sourceType,
      this.isClothingCategory,
      this.submitData
    );
    return getRules(fieldName);
  }
  /**
   * 是否显示某字段
   */
  get fieldVisible(): (field: string) => boolean {
    const visible = getFieldCtrlFn<boolean>(
      isFieldVisible,
      this.sourceType,
      this.isClothingCategory,
      this.submitData
    );
    return (field: string) => {
      return visible(field);
    };
  }
  /**
   *是否字段必填
   */
  get fieldRequired(): (field: string) => boolean {
    const isRequired = getFieldCtrlFn<boolean>(
      isFieldRequired,
      this.sourceType,
      this.isClothingCategory,
      this.submitData
    );
    return (field: string) => {
      return isRequired(field);
    };
  }
  /**
   * 获取字段校验配置
   * @param fieldNames
   * @returns
   */
  getFieldsRules(fieldNames: string[]): ElementUIFormRules {
    const getRules = getFieldsCtrlFn<ElementUIFormRules>(
      getFieldsRules,
      this.sourceType,
      this.isClothingCategory,
      this.submitData
    );
    return getRules(fieldNames);
  }
  /** 获取ElementUI form表单组件引用 */
  abstract getFormRef(): Form;
  reset(): void {
    const form = this.getFormRef();
    form.resetFields();
  }
  validate(): Promise<boolean> {
    const form = this.getFormRef();
    return form.validate().catch(() => false);
  }
  scrollErrorIntoView(): HTMLElement | null {
    const form = this.getFormRef();
    return scrollElementFormErrorIntoView(form);
  }
  /**
   * 数据填充到表单(取交集)
   */
  patchFormData(formData: FormModel) {
    patchData(formData, this.form);
    // const syncData = function (data: FormModel, key: string, path?: string) {
    //   if (
    //     data[key] &&
    //     typeof data[key] === "object" &&
    //     !Array.isArray(data[key])
    //   ) {
    //     Object.keys(data[key] as FormModel).forEach((k) => {
    //       const newPath = path ? `${path}.${key}` : key;
    //       syncData(data[key] as FormModel, k, newPath);
    //     });
    //   } else if (data[key] !== undefined) {
    //     const valuePath = path ? `${path}.${key}` : key;
    //     const value = get(formData, valuePath);
    //     if (value !== undefined) {
    //       data[key] = value;
    //     }
    //   }
    // };
    // Object.keys(this.form).forEach((key) => {
    //   syncData(this.form, key);
    // });
  }
}
